'use client';

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import { useT } from '@/hooks';
import type { BaseMenuItemConfig, PrimaryMenuItemConfig } from '@/types/component.types';

import { PALETTE_KEYS } from '@/constants/theme.constants';

interface DropdownItemProps {
  item: PrimaryMenuItemConfig | BaseMenuItemConfig;
  xw;
  onClick: (item: BaseMenuItemConfig) => void;
}

export const DropdownItem = ({ item, onClick }: DropdownItemProps) => {
  const { t } = useT();
  const isPrimary = 'path' in item && !!item.path;

  return (
    <MenuItem
      onClick={() => onClick(item)}
      sx={{
        py: 1.25,
        px: 1.5,
        borderRadius: 2,
        mx: 1,
        mb: 0.5,
        cursor: 'pointer',
        '&:hover': { bgcolor: PALETTE_KEYS.BACKGROUND_HOVER },
      }}
    >
      {'icon' in item && item.icon && (
        <ListItemIcon sx={{ minWidth: 32, color: item.color, fontSize: '1.125rem' }}>
          {item.icon}
        </ListItemIcon>
      )}
      <ListItemText
        primary={t(item.label)}
        primaryTypographyProps={{
          fontSize: '0.875rem',
          fontWeight: isPrimary ? 500 : 400,
          color: isPrimary ? 'inherit' : PALETTE_KEYS.TEXT_SECONDARY,
        }}
      />
    </MenuItem>
  );
};
